<div class="change-password-dialog">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" class="change-password-dialog__progress"></mat-progress-bar>

  <div class="change-password-dialog__top-accent" aria-hidden="true"></div>

  <header class="change-password-dialog__header">
    <div class="change-password-dialog__hero" aria-hidden="true">
      <mat-icon>lock</mat-icon>
    </div>
    <div class="change-password-dialog__heading">
      <h2 class="change-password-dialog__title">{{ 'auth.changePassword.dialogTitle' | translate }}</h2>
      <p class="change-password-dialog__subtitle">{{ 'auth.changePassword.dialogSubtitle' | translate }}</p>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="onCancel()"
      class="change-password-dialog__close"
      [disabled]="loading"
      [attr.aria-label]="'common.close' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="change-password-dialog__form">
    <section class="change-password-dialog__body">
      <div class="change-password-dialog__field-block">
        <label class="change-password-dialog__label">
          {{ 'auth.changePassword.oldPassword' | translate }}
          <span class="change-password-dialog__required">*</span>
        </label>
        <mat-form-field appearance="outline" class="change-password-dialog__field">
          <input
            matInput
            [type]="hideOldPassword ? 'password' : 'text'"
            formControlName="oldPassword"
            [placeholder]="'auth.changePassword.oldPasswordPlaceholder' | translate"
            autocomplete="current-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="change-password-dialog__suffix-btn"
            (click)="toggleOldPasswordVisibility()"
            [attr.aria-label]="'common.showHidePassword' | translate"
            [attr.aria-pressed]="!hideOldPassword"
          >
            <mat-icon>{{ hideOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="oldPasswordControl?.hasError('required')">
            {{ 'auth.changePassword.oldPasswordRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="oldPasswordControl?.hasError('minlength')">
            {{ 'auth.changePassword.passwordMinLength' | translate }}
          </mat-error>
          <mat-error *ngIf="oldPasswordControl?.hasError('maxlength')">
            {{ 'auth.changePassword.passwordMaxLength' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="change-password-dialog__field-block">
        <label class="change-password-dialog__label">
          {{ 'auth.changePassword.newPassword' | translate }}
          <span class="change-password-dialog__required">*</span>
        </label>
        <mat-form-field appearance="outline" class="change-password-dialog__field">
          <input
            matInput
            [type]="hideNewPassword ? 'password' : 'text'"
            formControlName="newPassword"
            [placeholder]="'auth.changePassword.newPasswordPlaceholder' | translate"
            autocomplete="new-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="change-password-dialog__suffix-btn"
            (click)="toggleNewPasswordVisibility()"
            [attr.aria-label]="'common.showHidePassword' | translate"
            [attr.aria-pressed]="!hideNewPassword"
          >
            <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="newPasswordControl?.hasError('required')">
            {{ 'auth.changePassword.newPasswordRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="newPasswordControl?.hasError('minlength')">
            {{ 'auth.changePassword.passwordMinLength' | translate }}
          </mat-error>
          <mat-error *ngIf="newPasswordControl?.hasError('maxlength')">
            {{ 'auth.changePassword.passwordMaxLength' | translate }}
          </mat-error>
          <mat-error *ngIf="newPasswordControl?.hasError('passwordPattern')">
            {{ 'auth.changePassword.passwordPattern' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="change-password-dialog__field-block">
        <label class="change-password-dialog__label">
          {{ 'auth.changePassword.confirmPassword' | translate }}
          <span class="change-password-dialog__required">*</span>
        </label>
        <mat-form-field appearance="outline" class="change-password-dialog__field">
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            [placeholder]="'auth.changePassword.confirmPasswordPlaceholder' | translate"
            autocomplete="new-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="change-password-dialog__suffix-btn"
            (click)="toggleConfirmPasswordVisibility()"
            [attr.aria-label]="'common.showHidePassword' | translate"
            [attr.aria-pressed]="!hideConfirmPassword"
          >
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="confirmPasswordControl?.hasError('required')">
            {{ 'auth.changePassword.confirmPasswordRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="confirmPasswordControl?.hasError('passwordMismatch')">
            {{ 'auth.changePassword.passwordMismatch' | translate }}
          </mat-error>
          <mat-error *ngIf="confirmPasswordControl?.hasError('maxlength')">
            {{ 'auth.changePassword.passwordMaxLength' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <footer class="change-password-dialog__footer">
      <button mat-button type="button" class="btn btn-cancel change-password-dialog__btn" (click)="onCancel()" [disabled]="loading">
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="submit"
        mat-flat-button
        class="btn-primary-flat btn-primary-flat--success change-password-dialog__btn"
        [disabled]="changePasswordForm.invalid || loading"
      >
        <mat-icon *ngIf="!loading">check_circle</mat-icon>
        <mat-icon *ngIf="loading" class="spin">refresh</mat-icon>
        {{ loading ? ('common.loading' | translate) : ('auth.changePassword.submit' | translate) }}
      </button>
    </footer>
  </form>
</div>
